import { createContext, useContext } from "react";
import type { FC, ReactNode } from "react";

interface GlobalContextType {
  treatmentPlanTerm: string;
  emailRegex: RegExp;
}

const Default: GlobalContextType = {
  treatmentPlanTerm: "",
  emailRegex: new RegExp(""),
};

const GlobalContext = createContext<GlobalContextType>(Default);

const useGlobalConfig = () => {
  const { emailRegex, treatmentPlanTerm } = useContext(GlobalContext);

  return { emailRegex, treatmentPlanTerm };
};

interface Props {
  treatmentPlanTerm: string;
  emailRegexString: string;
  children: ReactNode;
}

const GlobalContextProvider: FC<Props> = ({ children, treatmentPlanTerm, emailRegexString }) => {
  const emailRegex = emailRegexString && new RegExp(emailRegexString);
  return (
    <GlobalContext.Provider value={{ treatmentPlanTerm, emailRegex }}>
      {children}
    </GlobalContext.Provider>
  );
};

export { GlobalContext, GlobalContextProvider, useGlobalConfig };
export type { GlobalContextType };
